import { createContext } from 'react';

const CopierContext = createContext(null);

export default CopierContext;
